import React, { useState } from 'react';
import PersonaGroups from './PersonaGroups';
import RegionManager from './RegionManager';
import ClassifierManager from './ClassifierManager';
import DeviceManager from './DeviceManager';
import ProxyManager from './ProxyManager';
import NarrativeManager from './NarrativeManager';
import BiasIndicatorManager from './BiasIndicatorManager';
import AppConfigManager from './AppConfigManager';
import OnboardingManager from './OnboardingManager';

type ConfigTab = 'personas' | 'regions' | 'classifiers' | 'devices' | 'proxies' | 'narratives' | 'bias-indicators' | 'app-configs' | 'onboarding';

const Configuration: React.FC = () => {
  const [activeTab, setActiveTab] = useState<ConfigTab>('personas');

  const tabs = [
    { id: 'personas' as ConfigTab, label: 'Persona Groups', component: PersonaGroups },
    { id: 'narratives' as ConfigTab, label: 'Narratives', component: NarrativeManager },
    { id: 'regions' as ConfigTab, label: 'Regions', component: RegionManager },
    { id: 'classifiers' as ConfigTab, label: 'Classifiers', component: ClassifierManager },
    { id: 'devices' as ConfigTab, label: 'Devices', component: DeviceManager },
    { id: 'proxies' as ConfigTab, label: 'Proxies', component: ProxyManager },
    { id: 'bias-indicators' as ConfigTab, label: 'Bias Indicators', component: BiasIndicatorManager },
    { id: 'app-configs' as ConfigTab, label: 'App Configs', component: AppConfigManager },
    { id: 'onboarding' as ConfigTab, label: 'Onboarding', component: OnboardingManager },
  ];

  const ActiveComponent = tabs.find(tab => tab.id === activeTab)?.component || PersonaGroups;

  return (
    <div className="configuration-page">
      <div className="configuration-header">
        <h1>Advanced Configuration</h1>
        <p className="text-secondary">Manage system resources and settings</p>
      </div>
      
      <div className="configuration-tabs">
        {tabs.map(tab => (
          <button
            key={tab.id}
            className={`config-tab ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => setActiveTab(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>
      
      <div className="configuration-content">
        <ActiveComponent />
      </div>
    </div>
  );
};

export default Configuration; 
